import { UseQueryResult } from "react-query";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { RemoteApiError } from "../useRemote/types";
import { VehicleBookingEventDto } from "../../../components/FleetManagement/types/FleetManagement-row.types";

export type VehicleBookingEventsParams = {
  vehicleId: number;
  startDate?: string; // ISO date (YYYY-MM-DD)
  endDate?: string; // ISO date (YYYY-MM-DD)
};

/**
 * Fetches booking events for a vehicle (GET /fleet/vehicles/:vehicleId/booking-events).
 * If startDate/endDate are omitted, returns all relevant upcoming booking events (end >= now).
 */
export function useRemoteFetchVehicleBookingEvents(
  params: VehicleBookingEventsParams | null
): UseQueryResult<VehicleBookingEventDto[], RemoteApiError> {
  const enabled = params != null && params.vehicleId != null;

  return useRemoteQuery<VehicleBookingEventDto[], RemoteApiError>({
    queryKey: [
      "fleet",
      "vehicles",
      params?.vehicleId,
      "booking-events",
      params?.startDate,
      params?.endDate
    ],
    url: `/fleet/vehicles/${params?.vehicleId}/booking-events`,
    params: params
      ? {
          ...(params.startDate ? { startDate: params.startDate } : {}),
          ...(params.endDate ? { endDate: params.endDate } : {})
        }
      : undefined,
    enabled
  });
}
